import React from "react";
import { groupBy } from "lodash";

import { Divider, Typography } from "@mui/material";
import Grid from "@mui/material/Grid2";

import { AudienceCard, CreateNewCard } from "@/components/atoms";
import { Audience, AudienceActions, PageState } from "@/types";


interface AudienceCardViewProps {
  audiences: Audience[];
  pageState: PageState;
  actions: AudienceActions
}

export const AudienceCardView: React.FC<AudienceCardViewProps> = ({
  audiences,
  pageState,
  actions
}) => {

  const hasNonProjectAudiences = audiences.filter(x => x.project_name === "null" || x.project_name == null).length > 0

  return (
    <>

      {!hasNonProjectAudiences && (
        <Grid container size={12} spacing={2}>
          <CreateNewCard
            title="Create New Audience"
            onClick={actions.createAudience}
          />
        </Grid>
      )}

      {/* Create a section for each project */}
      {Object.entries(groupBy(audiences, "project_name")).map(
        ([project, projectAudiences], idx) => (
          <React.Fragment key={idx}>
            {/* Don't show a header if there's no project unless a filter has been applied */}
            {(project !== "null" || pageState.filterApplied) && (
              <Grid size={12}>
                <Divider textAlign="left">
                  <Typography variant="h5">
                    {project !== "null" ? project : ""}
                  </Typography>
                </Divider>
              </Grid>
            )}

            {/* Create Audience Card - Only show if no filter has been applied */}
            <Grid container size={12} spacing={2}>
              {project === "null" && !pageState.filterApplied && (
                <CreateNewCard
                  title="Create New Audience"
                  onClick={actions.createAudience}
                />
              )}

              {/* Project Audience Cards */}
              {projectAudiences.map((audience, index) => (
                <Grid key={index}>
                  <AudienceCard
                    audience={audience}
                    actions={actions}
                  />
                </Grid>
              ))}
            </Grid>
          </React.Fragment>
        )
      )}
    </>
  );
};

export default AudienceCardView;
